const { h, render, Component } = require('preact');

class TextParagraph extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var attrs = this.props.attrs
    var labels = this.props.attrs.label.split('\\n')

    var textLines = [];

    _.each(labels, function(label, index) {
      textLines[index] = {};
      return textLines[index].text = label;
    });

    var labels = textLines

    return (
      <div class="important-note-container" data-bhw={'text_paragraph' + attrs.counter} id = {'text_paragraph' + attrs.counter}>
        <p class="important-note-header">
          <label class="stepThreeLabel"> <strong>
            {I18n.translate('js.modules.support.important_note')}</strong>
          </label>
        </p>
        {
          labels.map((item) =>
            <p class="important-note">
              <label class="stepThreeLabel">{item.text}</label>
            </p>
          )
        }
      </div>
    )
  }
}

module.exports = TextParagraph
